<template>
    <div class="foot">
        <table></table>
        <div>
            <div>
                <p>北京华工恒达科技有限公司</p>
            <p>全国服务热线：010-56268817（8:30-18:00）</p>
            <p>24小时销售热线：13391633268</p>
            <p>地址：北京市房山区天星街1号院14号楼1206室</p>           
            </div>
            <div data-v-54631763="" class="bottom"><img data-v-54631763="" src="http://upload.lusenky.com/upload/we/image.png" alt=""></div>
        </div>
        <p>关键词：防雷工程|特种防雷|防雷产品|防雷器|避雷器|接地|接地产品|机电与防雷工程|安防监控产品|消防工程|智能家居</p>
        <p style="margin:10px 0 0px">版权所有：北京华工恒达科技有限公司 北京露森技术服务有限公司
            
               <div style="width:450px;margin:0 auto; padding:20px 0;"><a style="color:#ffffff;padding-bottom:10px;" href="http://www.beian.miit.gov.cn/"> 京ICP备19012190号-4</a>
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011102001279" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#ffffff;"><img src="http://upload.lusenky.com/kt/KTImg/1582533419068.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">京公网安备 11011102001279号</p></a>
                </div>
        </p>
        <p></p>
    </div>
</template>
<script>
export default {

}
</script>
<style scoped>
.foot{
    height: 350px;
    background: #000;
    color: white;
}
.foot>div{
width: 1074px;
margin: 38px auto 20px;
display: flex;
justify-content: space-between;
}
.foot>p{
    text-align: center;
}
.foot p{
    margin:15px 0;
}
.bt11{
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
}
.bottom img[data-v-54631763] {
    margin-top: 27px;
    width: 100px;
    padding-left: 66px;
}
</style>